import DuckEntity from './DuckEntity'
import queryString from "query-string";
import {apiAction, apiFetch} from "utils";

const entity = new DuckEntity('checklistAnswers');
const reducer = entity.reducer;

entity.actions.completeBasic = (checklist_answer_id) =>
  apiAction(
    entity.types.SAVE_BEGIN, entity.types.SAVE_SUCCESS, entity.types.SAVE_ERROR,
    (state) => apiFetch.post(state, `${entity.config.apiPath}/${checklist_answer_id}/complete_basic`),
    {checklist_answer_id},
    {checklist_answer: entity.schema}
  );

export {reducer as default, entity};
